module.exports = require("./gd.js");